import { useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { partnersWidgetInViewport } from '@cred/react-analytics/events'
import { fireGtmEvent } from 'utils/gtm'
import { WidgetContext } from 'App'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'

const ViewportAnalytics = ({ seen, trackSnowplowEvent }) => {
  const widgetContext = useContext(WidgetContext)

  useEffect(() => {
    if (seen) {
      trackSnowplowEvent(partnersWidgetInViewport, {})
      fireGtmEvent('partnerWidgetInViewport', widgetContext)
    }
  }, [seen, trackSnowplowEvent, widgetContext])

  return null
}

ViewportAnalytics.propTypes = {
  seen: PropTypes.bool.isRequired,
}

export default withSnowplowContexts(ViewportAnalytics)
